import { useState, useCallback } from 'react';
import { pagosFacturasAPI } from '../services/pagosFacturasAPI';
import { validarArchivo as validarArchivoUtil } from '../utils/validarArchivo';

const TIPOS_CONSTANCIA_VALIDOS = [
  'Comprobante de Transferencia',
  'Cheque Recibido',
  'Captura de Pantalla',
];

export const useAdjuntarConstancia = () => {
  const [archivo, setArchivo] = useState(null);
  const [tipoConstancia, setTipoConstancia] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const validarArchivo = useCallback((file) => {
    return validarArchivoUtil(file);
  }, []);

  const handleSetArchivo = useCallback((file) => {
    const resultado = validarArchivo(file);
    if (!resultado.valid) {
      setError(resultado.error);
      return;
    }
    setError(null);
    setArchivo(file);
  }, [validarArchivo]);

  const handleSetTipoConstancia = useCallback((tipo) => {
    setTipoConstancia(tipo);
    if (error === 'Seleccione el tipo de constancia') {
      setError(null);
    }
  }, [error]);

  const canSubmit = useCallback(() => {
    return archivo !== null && TIPOS_CONSTANCIA_VALIDOS.includes(tipoConstancia) && !loading;
  }, [archivo, tipoConstancia, loading]);

  const submit = useCallback(async (idFactura) => {
    if (!archivo) {
      setError('Debe seleccionar un archivo');
      return null;
    }

    if (!TIPOS_CONSTANCIA_VALIDOS.includes(tipoConstancia)) {
      setError('Seleccione el tipo de constancia');
      return null;
    }

    setLoading(true);
    setError(null);

    try {
      const formData = new FormData();
      formData.append('file', archivo);
      formData.append('IdAdjuntoFacturaOS', idFactura);
      formData.append('TipoConstancia', tipoConstancia);

      const result = await pagosFacturasAPI.adjuntarConstancia(formData);
      return result;
    } catch (err) {
      const errorMsg = err.response?.data?.message
        || 'No se pudo completar la operación. Intente nuevamente.';
      setError(errorMsg);
      return null;
    } finally {
      setLoading(false);
    }
  }, [archivo, tipoConstancia]);

  const reset = useCallback(() => {
    setArchivo(null);
    setTipoConstancia('');
    setError(null);
    setLoading(false);
  }, []);

  return {
    archivo,
    tipoConstancia,
    error,
    loading,
    setArchivo: handleSetArchivo,
    setTipoConstancia: handleSetTipoConstancia,
    validarArchivo,
    canSubmit,
    submit,
    reset,
  };
};
